








































import { defineComponent } from "@vue/composition-api";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { printCost } from "@/lib/moneyHelpers";
import BaseButton from "@/components/BaseButton";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseConfirm from "@/components/BaseConfirm";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "SubscriptionConfirmModal",
  components: { BaseCheckbox, FormatMoney, BaseButton, BaseConfirm },
  props: {
    show: { type: Boolean },
    selectedSubscriptionLevel: { type: Object as () => SubscriptionLevel | null },
    user: { type: Object as () => UserPublicData, required: true },
    cost: { type: Number },
    mainCurrency: { type: String, required: true },
    paymentSystemId: { type: String, required: true },
  },
  data() {
    return {
      currentAmount: 0,
      isChecked: false,
      isUpgrade: false,
    };
  },
  watch: {
    async selectedSubscriptionLevel() {
      if (!this.selectedSubscriptionLevel) return;
      this.currentAmount = await providers.SubscriptionUpgradeProvider.initialAmountFind({
        data: {
          currency: this.mainCurrency,
          levelId: this.selectedSubscriptionLevel.id,
          paymentSystemId: this.paymentSystemId,
        },
      });
      this.isUpgrade = this.currentAmount !== this.cost;
      this.isChecked = this.isUpgrade;
    },
  },
  computed: {
    title(): string {
      return this.isUpgrade ? $t("Upgrade your subscription") : $t("Confirm subscription");
    },
    formattedPrice(): string {
      return printCost(this.currentAmount);
    },
    confirmButtonText(): string {
      return this.isUpgrade ? $t("Upgrade") : $t("Subscribe for {0}/mo", [this.formattedPrice]);
    },
  },
  methods: {
    subscribe() {
      this.isChecked = false;
      this.$emit("subscribe", this.selectedSubscriptionLevel);
    },
    cancelUpgradeLevel() {
      this.currentAmount = 0;
      this.isChecked = false;
      this.$emit("cancelUpgradeLevel");
    },
  },
});
